<template>
  <!-- eslint-disable -->
  <div class="player-card" v-if="currentPlayer">
    <div class="header">
      <div class="header">
        <i class="el-icon-arrow-left" @click="handlePrev"></i>
        <i class="el-icon-arrow-right" @click="handleNext"></i>
        <i class="el-icon-close" @click="handleClose"></i>
        <div class="background">
          <div class="bg1"></div>
          <div class="bg2"></div>
        </div>

        <div
          class="headshot fadeIn"
          :style="{ 'background-image': `url(${currentHeadshot})` }"
        ></div>
        <div class="info fadeIn">
          <h3 class="tw-mb-3">
            {{ playerNames(currentPlayer.profile) }}
          </h3>
          <h4>
            <span class="player-role"
              >{{ isPlayer ? "Player" : currentPlayer.role.replace("-", " ") }} #{{
                currentPlayer.shirtNum
              }}</span
            >
          </h4>
        </div>
      </div>
    </div>

    <div class="player-info-row fadeIn">
      <div
        class="suspension-info"
        v-if="currentPlayer.available && currentPlayer.available.is === false"
      >
        <h5 class="suspension-text">Suspended until {{ formatDate(currentPlayer) }}</h5>
        <hr />
      </div>
      <div class="player-info-column">
        <h4 class="tw-pt-2 tw-pb-5 team-name">{{ team.name }}</h4>
        <hr />
        <div class="tw-grid tw-grid-cols-2 info-line">
          <div class="info-name">Date of Birth</div>
          <div class="info-value">{{ formatDate(currentPlayer.profile.dob) }}</div>
        </div>
        <hr />
        <div class="tw-grid tw-grid-cols-2 info-line">
          <div class="info-name ">ID No</div>
          <div class="info-value">{{ currentPlayer._id }}</div>
        </div>
        <hr />
        <div class="tw-grid tw-grid-cols-2 info-line">
          <div class="info-name ">Competition</div>
          <div class="info-value">{{ competition.name }}</div>
        </div>
        <hr />
        <div
          v-for="dispensation in currentPlayer.dispensations"
          :key="dispensation.rule"
          v-if="isPlayer === true"
        >
          <div class="tw-grid tw-grid-cols-2 info-line">
            <div class="info-name">Dispensations</div>
            <div class="info-value">{{ dispensation.rule }}</div>
          </div>
          <hr />
        </div>

        <div
          class="tw-w-full tw-pt-3 tw-m-0 tw-mt-6 tw-mb-8 tw-bg-white"
          v-if="isPlayer === false && currentPlayer.accreditations.length > 0"
        >
          <div id="tableHeader" class="tw-grid tw-object-top tw-grid-cols-3 tw-mb-3">
            <div class="tw-flex-1 tw-px-4 tw-text-xs tw-font-medium tw-text-black tw-w-150">
              Accreditation
            </div>
            <div class="tw-flex-1 tw-px-4 tw-text-xs tw-font-medium tw-text-black tw-w-150">
              Status
            </div>
            <div class="tw-flex-1 tw-px-4 tw-text-xs tw-font-medium tw-text-black tw-w-150">
              Expiry
            </div>
          </div>
          <hr class="tw-w-full tw-mb-4" />
          <div
            class="tw-grid tw-grid-cols-3 tw-pb-4"
            v-for="player in currentPlayer.accreditations"
            :key="currentPlayer._id"
            style="width: 100%"
          >
            <div
              class="tw-h-3 tw-px-4 tw-text-xs tw-font-normal tw-leading-3 tw-text-left tw-w-150"
              v-if="player.skillName"
            >
              {{ player.skillName }}
            </div>
            <div v-else></div>
            <div
              class="tw-h-3 tw-px-4 tw-text-xs tw-font-normal tw-leading-3 tw-text-left tw-w-150"
            >
              {{ getAccreditationStatus(player) }}
            </div>

            <div
              class="tw-h-3 tw-px-4 tw-text-xs tw-font-normal tw-leading-3 tw-text-left tw-w-150"
              v-if="player.expiry"
            >
              {{ player.expiry }}
            </div>
            <div v-else></div>
          </div>
        </div>

        <div class="club-info" v-if="club">
          <img :src="club.meta.avatar" class="club-avatar" />
          <h4 class="club-name">{{ club.name }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "@/utils/dayjs";
import _, { sortBy } from "lodash";

export default {
  props: {
    isPlayer: { type: Boolean, required: true },
    players: { type: Array, required: true },
    competition: { type: Object, required: true },
    team: { type: Object, required: true },
    club: { type: Object, required: false }
  },
  data() {
    return {
      currentIndex: 0,
      sortedPlayers: sortBy(this.players, player => parseInt(player.shirtNum))
    };
  },
  mounted() {},
  methods: {
    formatDate(date) {
      return dayjs(date).format("Do MMM YYYY");
    },
    handleNext() {
      const { currentIndex } = this;
      if (currentIndex === this.sortedPlayers.length - 1) {
        this.currentIndex = 0;
      } else {
        this.currentIndex += 1;
      }
    },
    handlePrev() {
      const { currentIndex } = this;
      if (currentIndex === 0) {
        this.currentIndex = this.sortedPlayers.length - 1;
      } else {
        this.currentIndex -= 1;
      }
    },
    handleClose() {
      this.$emit("close");
    },
    getAccreditationStatus(scope) {
      if (scope.expiry) {
        return dayjs(scope.expiry).valueOf() <= dayjs().valueOf() ? "Expired" : "Active";
      }
      return "";
    },
    playerNames(profile) {
      const firstName = profile.preferNameStatus ? (profile.preferFirstName || profile.firstName) : profile.firstName;
      const lastName = profile.preferNameStatus ? (profile.preferLastName || profile.lastName) : profile.lastName;
      return `${firstName} ${lastName}`;
    }
  },
  computed: {
    currentHeadshot() {
      return this.currentPlayer && this.currentPlayer.profile && this.currentPlayer.profile.meta
        ? this.currentPlayer.profile.meta.avatar
        : "";
    },
    currentPlayer() {
      return this.sortedPlayers ? this.sortedPlayers[this.currentIndex] : false;
    }
  }
};
</script>

<style lang="scss" scoped>
.player-card {
  height: 100%;
  width: 100%;
  background-color: #fff;

  @media only screen and (min-width: $sm) {
    max-width: 375px;
    max-height: 100%;
  }
}

.header {
  width: 100%;
  height: 20rem;
  position: relative;
  .background {
    width: 100%;
    height: 100%;
    display: flex;
    .bg1 {
      width: 50%;
      height: 100%;
      background: black;
    }
    .bg2 {
      background: black;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0 20rem 50vw;
      border-color: transparent transparent #262626 transparent;
    }
  }

  @media only screen and (min-width: $sm) {
    .background {
      display: flex;
      overflow: hidden;
      flex-wrap: wrap;
      flex-direction: column;
      .bg2 {
        background: black;
        width: 50vw;
        height: 0;
        border-style: solid;
        border-width: 0 0 20rem 187.5px;
        border-color: transparent transparent #262626 transparent;
      }
    }
  }
  .headshot {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 6rem;
    height: 6rem;
    background: white;
    border-radius: 200px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .info {
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    text-align: center;
    font-family: $fontMedium;
    h3 {
      font-weight: 600;
    }
    h4 {
      font-weight: 400;
      margin-block-start: -0.5rem;
    }
    .player-role {
      text-transform: capitalize;
    }
  }
}

.player-info-row {
  hr {
    border: none;
    height: 1px;
    /* Set the hr color */
    color: #ebeef5; /* old IE */
    background-color: #ebeef5; /* Modern Browsers */
  }
  background: white;
  width: 100%;
  padding: 1rem;
  .suspension-info {
    text-align: center;
    color: #d0021b;
    .suspension-text {
      margin: 0;
      font-weight: 500;
    }
  }
  .player-info-column {
    .team-name,
    .info-line {
      width: 100%;
    }
    .team-name {
      text-align: center;
      font-weight: 500;
    }
    .info-line {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      font-size: 0.9rem;
      .info-name {
        font-weight: 500;
        padding-left: 0.45rem;
        padding-right: 0.45rem;
      }
      .info-value {
        font-weight: 400;
        font-family: $font;
      }
    }

    .club-info {
      margin-top: 2rem;
      margin-bottom: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .club-avatar {
        width: 2.5rem;
        margin-right: 1rem;
      }
      .club-name {
        font-weight: 500;
      }
    }
  }
}

.el-icon-arrow-left,
.el-icon-arrow-right {
  position: absolute;
  top: 50%;
  color: white;
  z-index: 1000;
  font-size: 1.8rem;
}

.el-icon-arrow-left {
  left: 5%;
}

.el-icon-arrow-right {
  right: 5%;
}

.el-icon-close {
  position: absolute;
  top: 6%;
  color: white;
  z-index: 1000;
  font-size: 1.8rem;
  right: 4%;
}
</style>
